import {Injectable} from '@angular/core'
import {CachedAPIRequest} from 'src/app/core/classes/cached.api.request.class'
import { HttpClient } from '@angular/common/http'
import {Router} from '@angular/router'
import {APIRequestResources} from 'src/app/core/enums/api.request.enum'
import {BehaviorSubject, take, tap} from 'rxjs'
import {toSignal} from "@angular/core/rxjs-interop";
import {SearchCustomerCategoryDTO} from "../interfaces/customer-category.entity";

@Injectable({
  providedIn: 'root'
})
export class CustomerCategoryService extends CachedAPIRequest {

  private readonly $all = new BehaviorSubject<SearchCustomerCategoryDTO[]>([]);
  all = toSignal(this.$all, {initialValue: []})

  private readonly $active = new BehaviorSubject<SearchCustomerCategoryDTO | undefined>(undefined);
  active = toSignal(this.$active, {initialValue: undefined})

  constructor(protected override http: HttpClient, private router: Router) {
    super(http, APIRequestResources.CustomerCategoryService)
    this.getAll( true).pipe(take(1)).subscribe()
  }

  getById = (id: any, refresh = false) => {
    return this.get<SearchCustomerCategoryDTO>({id}, refresh ? 'freshness' : 'performance')
      .pipe(
        tap((res) => this.$active.next(res.data)),
      )
  }

  getAll = (refresh = false) => {
    return this.get<SearchCustomerCategoryDTO[]>({ endpoint: `all` }, refresh ? 'freshness' : 'performance')
      .pipe(
        tap((res) => this.$all.next(res.data)),
      )
  }

  find = (searchParams: any, refresh = false) => {
    return this.get<SearchCustomerCategoryDTO[]>({ endpoint: `find`, params: searchParams}, refresh ? 'freshness' : 'performance')
      .pipe(
        tap((res) => this.$all.next(res.data)),
      )
  }

}
